import moment from 'moment-timezone';
import { isMarketplacePickupSale } from '../Sales/PreDelivering/Helper/MarketplacePickupHelper';

const JAKARTA = 'Asia/Jakarta';

export const RETURN_STATUS_LABELS = {
  OUTSTANDING: 'Outstanding',
  QC: 'Quality Control',
  LC: 'Legit check',
  FOLLOW_UP: 'Follow up',
  APPROVED: 'Return approved',
  RELISTING: 'Need relisting',
  NEED_REFUND: 'Need return refund',
  PRE_DELIVERING: 'Pre-delivering',
  DELIVERING: 'Delivering',
  PROCESSED: 'Processed',
  REJECTED: 'Rejected',
  DONE: 'Processed',
};

export const RETURN_SHIPMENT_COURIERS = [
  { value: 'jnt', label: 'JNT' },
  { value: 'tiki', label: 'TIKI' },
  { value: 'spx', label: 'SPX' },
  { value: 'instant_courier', label: 'Gosend/Grab' },
  { value: 'warehouse', label: 'Warehouse' },
  { value: 'others', label: 'Others' },
];

export const QUEUE_ACTIONS = {
  outstanding: [
    { kind: 'receipt', label: 'Receive From Buyer' },
  ],
  qc: [
    { kind: 'pass', label: 'Pass' },
    { kind: 'fail', label: 'Fail' },
  ],
  relisting: [
    { kind: 'relist', label: 'Relist' },
  ],
  refund: [
    { kind: 'refund', label: 'Record refund' },
  ],
  follow_up: [
    { kind: 'buyer_approve', label: 'Return Approved' },
    { kind: 'buyer_reject', label: 'Sending Back To Buyer' },
  ],
  pre_delivering: [
    { kind: 'shipment', label: 'Save shipment' },
  ],
  delivering: [
    { kind: 'reject', label: 'Complete return' },
  ],
};

export const returnQueueActions = (queue, sale) => {
  if (queue === 'pre_delivering' && isMarketplacePickupSale(sale)) {
    return [{ kind: 'pickup', label: 'Confirm Pickup' }];
  }
  return QUEUE_ACTIONS[queue] || [];
};

const ACTION_PATHS = {
  awb: 'return-process',
  receipt: 'return-receipt',
  pass: 'return-inspection',
  fail: 'return-inspection',
  buyer_approve: 'return-decision',
  buyer_reject: 'return-decision',
  relist: 'return-relist',
  refund: 'return-refund',
  pickup: 'return-dispatch',
  shipment: 'return-shipment',
  dispatch: 'return-dispatch',
  reject: 'return-reject',
};

export const returnActionPath = (kind) => ACTION_PATHS[kind];

export const readSaleReturn = (sale = {}) => {
  const record = sale.sale_return || sale.saleReturn || null;
  if (record == null) return { record: null, data: {} };

  let data = record.data;
  if (typeof data === 'string') {
    try {
      data = JSON.parse(data);
    } catch (err) {
      console.error('Return data is not valid JSON', err);
      data = {};
    }
  }

  return {
    record,
    data: data != null && typeof data === 'object' ? data : {},
  };
};

export const isReturnRelisted = (sale) => {
  const { record, data } = readSaleReturn(sale);
  return Boolean((record && Number(record.relisted_user_sell_id) > 0) || data.relisted_at);
};

export const returnStatusLabel = (sale) => {
  const { record } = readSaleReturn(sale);
  if (record == null || record.status == null) return null;
  return RETURN_STATUS_LABELS[record.status] || record.status;
};

export const returnErrorMessage = (err) => {
  const data = err && err.response ? err.response.data : null;
  if (data == null) return 'The request failed. Please try again.';

  const fieldErrors = data.error && data.error.errors;
  if (fieldErrors != null && typeof fieldErrors === 'object') {
    const firstKey = Object.keys(fieldErrors).find((key) => (
      Array.isArray(fieldErrors[key]) && fieldErrors[key][0]
    ));
    if (firstKey) return fieldErrors[firstKey][0];
  }

  if (data.error && data.error.message && data.error.message !== 'Unprocessable Entity') {
    return data.error.message;
  }
  if (data.message) return data.message;
  if (data.error && data.error.message) return data.error.message;
  return 'The request failed. Please try again.';
};

export const listErrorMessage = (error) => {
  if (error == null) return null;
  if (error.message) return error.message;
  if (error.error && error.error.message) return error.error.message;
  return 'Unable to load returns.';
};

export const jakartaDateTimeLocalNow = () => moment.tz(JAKARTA).format('YYYY-MM-DDTHH:mm');

const JAKARTA_LOCAL_FORMATS = ['YYYY-MM-DDTHH:mm:ss', 'YYYY-MM-DDTHH:mm'];

export const jakartaDateTimeFromLocal = (value) => {
  if (value == null || value === '') return null;
  const parsed = moment.tz(value, JAKARTA_LOCAL_FORMATS, true, JAKARTA);
  return parsed.isValid() ? parsed.format('YYYY-MM-DD HH:mm:ss') : null;
};

export const returnCourierLabel = (courier) => {
  if (courier == null || courier === '') return null;
  if (typeof courier !== 'string') return courier;
  const match = RETURN_SHIPMENT_COURIERS.find(
    (option) => option.value === courier.toLowerCase()
  );
  return match ? match.label : courier;
};

export const isPositiveAskingPrice = (value) => {
  const trimmed = String(value == null ? '' : value).trim();
  return /^\d+$/.test(trimmed) && !/^0+$/.test(trimmed);
};
